import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-suggested-delears',
    templateUrl: './suggested-delears.component.html',
    styleUrls: ['./suggested-delears.component.scss']
})
export class SuggestedDelearsComponent implements OnInit {
    @Input() dealers = [];
    @Input() loading: boolean = null;

    constructor() {}

    ngOnInit() {}

    sanitizedPhone (phone) {
        if (!phone) {
            return '';
        }
        return phone.toString().replace(/\D/g, '');
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/suggested-delears/suggested-delears.component.ts